// extracted by mini-css-extract-plugin
module.exports = {"withwhom":"WithWhoList_withwhom__9_y1p","bigButton":"WithWhoList_bigButton__2j-GK","zoomHover":"WithWhoList_zoomHover__xltbO"};